import { GAME_KEYS } from "./game.constants"

export const isGameFPS = gameKey =>
  [
    GAME_KEYS.APEX_LEGENDS,
    GAME_KEYS.COD_COLD_WAR,
    GAME_KEYS.COD_MODERN_WARFARE,
    GAME_KEYS.COD_WARZONE,
    GAME_KEYS.CSGO,
    GAME_KEYS.DESTINY2,
    GAME_KEYS.FORTNITE,
    GAME_KEYS.OVERWATCH,
    GAME_KEYS.PUBG,
    GAME_KEYS.RAINBOW_SIX_SIEGE,
    GAME_KEYS.VALORANT,
  ].includes(gameKey)



// WEBPACK FOOTER //
// ./src/store/game/game.utils.js